'use client'

import {createContext, useContext, useEffect, useState, ReactNode} from 'react'

const InteractionContext = createContext<boolean>(false)

interface Props {
  children: ReactNode
}

export function UserInteractionProviderClient({children}: Props) {
  const [hasInteracted, setHasInteracted] = useState<boolean>(false)

  useEffect(() => {
    if (hasInteracted) return

    function handleInteraction() {
      setHasInteracted(true)
      document.removeEventListener('scroll', handleInteraction)
      document.removeEventListener('mousemove', handleInteraction)
      document.removeEventListener('touchmove', handleInteraction)
    }

    document.addEventListener('scroll', handleInteraction, {once: true, passive: true})
    document.addEventListener('mousemove', handleInteraction, {once: true, passive: true})
    document.addEventListener('touchmove', handleInteraction, {once: true, passive: true})

    return () => {
      document.removeEventListener('scroll', handleInteraction)
      document.removeEventListener('mousemove', handleInteraction)
      document.removeEventListener('touchmove', handleInteraction)
    }
  }, [hasInteracted])

  return <InteractionContext.Provider value={hasInteracted}>{children}</InteractionContext.Provider>
}

export function useInteractionDetected(): boolean {
  return useContext(InteractionContext)
}
